import OrderTypes from "./types";

const INITIAL_STATE = {
  data: null,
  pickup_location: {
    pickAddress: "",
    pickLabel: "",
    pickLocation: [],
    pickNotes: "",
    pickPhoneName: "",
    pickPhoneNumber: "",
    senderName: "",
  },
  item_drop: [],
  reRouting: null,
};

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OrderTypes.SET_TEMP_ORDER:
      return {
        ...state,
        data: action.payload,
      };
    case OrderTypes.SET_PICKUP_LOCATION:
      return {
        ...state,
        pickup_location: action.payload,
      };
    case OrderTypes.SET_ITEM_DROP:
      return {
        ...state,
        item_drop: action.payload,
      };
    case OrderTypes.SET_RE_ROUTING:
      return {
        ...state,
        reRouting: action.payload,
      };
    default:
      return state;
  }
};

export default authReducer;
